import { Input } from "../atoms/Input.tsx";
import { Button } from "../atoms/Button.tsx";
import { IconButton } from "../atoms/IconButton.tsx";

export interface LinkRow {
  label: string;
  url: string;
}

interface Props {
  rows: LinkRow[];
  onChange: (rows: LinkRow[]) => void;
  labelPlaceholder: string;
  urlPlaceholder: string;
  addLabel: string;
  max?: number;
}

/** Editor for an array of {label, url} rows (projects links). */
export function LinkRowsEditor({ rows, onChange, labelPlaceholder, urlPlaceholder, addLabel, max = 6 }: Props) {
  const set = (i: number, patch: Partial<LinkRow>) =>
    onChange(rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  return (
    <div>
      {rows.map((row, i) => (
        <div className="repeat-row" key={i}>
          <Input value={row.label} placeholder={labelPlaceholder} onChange={(e) => set(i, { label: e.target.value })} />
          <Input value={row.url} placeholder={urlPlaceholder} onChange={(e) => set(i, { url: e.target.value })} />
          <IconButton type="button" aria-label="Remove row" onClick={() => onChange(rows.filter((_, idx) => idx !== i))}>
            ✕
          </IconButton>
        </div>
      ))}
      {rows.length < max && (
        <Button type="button" size="sm" onClick={() => onChange([...rows, { label: "", url: "" }])}>
          + {addLabel}
        </Button>
      )}
    </div>
  );
}

interface PillProps {
  rows: { label: string }[];
  onChange: (rows: { label: string }[]) => void;
  max?: number;
}

/** Editor for an array of {label} pills (settings nowPills). */
export function PillRowsEditor({ rows, onChange, max = 6 }: PillProps) {
  return (
    <div>
      {rows.map((row, i) => (
        <div className="repeat-row single" key={i}>
          <Input
            value={row.label}
            placeholder="Shipping envault"
            onChange={(e) => onChange(rows.map((r, idx) => (idx === i ? { label: e.target.value } : r)))}
          />
          <IconButton type="button" aria-label="Remove pill" onClick={() => onChange(rows.filter((_, idx) => idx !== i))}>
            ✕
          </IconButton>
        </div>
      ))}
      {rows.length < max && (
        <Button type="button" size="sm" onClick={() => onChange([...rows, { label: "" }])}>
          + Add pill
        </Button>
      )}
    </div>
  );
}
